import React, { useState, useEffect } from 'react';
import './AnnotationPanel.css';

export default function AnnotationPanel({ logId, token, currentUser, onClose }) {
  const [annotations, setAnnotations] = useState([]);
  const [newContent, setNewContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const fetchAnnotations = async () => {
    try {
      const res = await fetch(`/api/work-logs/${logId}/annotations`, {
        headers: { 'x-token': token }
      });
      const data = await res.json();
      setAnnotations(Array.isArray(data) ? data : []);
    } catch (e) { 
      console.error(e); 
      setAnnotations([]);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchAnnotations();
  }, [logId]);

  const handleSubmit = async () => {
    if (!newContent.trim()) return;
    setSubmitting(true);
    try {
      const res = await fetch(`/api/work-logs/${logId}/annotations`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify({ content: newContent.trim() })
      });
      
      if (!res.ok) {
        const errorData = await res.json().catch(() => ({ error: '请求失败' }));
        console.error('批注提交失败:', errorData);
        alert(errorData.error || '提交失败，请重试');
        setSubmitting(false);
        return;
      }
      
      setNewContent('');
      await fetchAnnotations();
    } catch (e) { 
      console.error('批注提交异常:', e);
      alert('网络错误，请重试');
    }
    setSubmitting(false);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('确定删除这条批注？')) return;
    try {
      await fetch(`/api/annotations/${id}`, {
        method: 'DELETE',
        headers: { 'x-token': token }
      });
      fetchAnnotations();
    } catch (e) { console.error(e); }
  };

  const formatTime = (dateStr) => {
    const date = new Date(dateStr);
    const now = new Date();
    const diff = now - date;
    if (diff < 60000) return '刚刚';
    if (diff < 3600000) return `${Math.floor(diff / 60000)}分钟前`;
    if (diff < 86400000) return `${Math.floor(diff / 3600000)}小时前`;
    return date.toLocaleDateString('zh-CN') + ' ' + date.toLocaleTimeString('zh-CN', { hour: '2-digit', minute: '2-digit' });
  };

  return (
    <div className="annotation-overlay" onClick={onClose}>
      <div className="annotation-panel-modal" onClick={e => e.stopPropagation()}>
        <div className="annotation-panel-header">
          <h3>💬 日志批注</h3>
          <button className="annotation-close-btn" onClick={onClose}>×</button>
        </div>

        <div className="annotation-list-area">
          {loading ? (
            <div className="annotation-loading">加载中...</div>
          ) : annotations.length === 0 ? (
            <div className="annotation-empty">暂无批注，来写第一条吧</div>
          ) : (
            <div className="annotation-conversation">
              {annotations.map(a => (
                <div key={a.id} className="annotation-bubble-row">
                  <div className="annotation-avatar">
                    {(a.user_name || a.user_id || '?')[0]}
                  </div>
                  <div className="annotation-bubble">
                    <div className="annotation-bubble-header">
                      <span className="annotation-author">{a.user_name || a.user_id}</span>
                      <span className="annotation-time">{formatTime(a.created_at)}</span>
                      {(a.user_id === currentUser || currentUser === 'jch') && (
                        <button className="annotation-del-btn" onClick={() => handleDelete(a.id)}>删除</button>
                      )}
                    </div>
                    <div className="annotation-bubble-content">{a.content}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="annotation-input-area">
          <textarea
            value={newContent}
            onChange={e => setNewContent(e.target.value)}
            placeholder="输入批注内容..."
            rows={4}
            onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSubmit(); } }}
          />
          <button 
            className="annotation-submit-btn" 
            onClick={handleSubmit}
            disabled={!newContent.trim() || submitting}
          >
            {submitting ? '发送中...' : '发送'}
          </button>
        </div>
      </div>
    </div>
  );
}
